"use client";
import CardForm, {
  CardFormBottom,
  CardFormInner,
  CardFormOutside,
} from "@/components/molecule/Cards/CardForm/CardForm";
import AuthLayout from "@/components/layouts/AuthLayout/AuthLayout";
import Input from "@/components/atom/Form/Input/Input";
import { useState } from "react";
import CheckBox from "@/components/atom/Form/Checkbox/CheckBox";
import Button from "@/components/atom/Form/Button/Button";
import { Link } from "@/navigation";
import { zodResolver } from "@hookform/resolvers/zod";
import { LoginInputSchema, TLoginInput } from "@/types/api/Auth/Login";
import { useForm } from "react-hook-form";
import { URL } from "@/utils/const/url";
import useFormErrorToast from "@/hooks/useFormToast";
import { useToast } from "@/contexts/ToastProvider";
import useLogin from "@/services/auth/useLogin";
import { useTranslations } from "next-intl";

const LoginForm = () => {
  const toast = useToast();
  const {
    handleSubmit,
    register,
    formState: { errors, isLoading },
  } = useForm<TLoginInput>({
    resolver: zodResolver(LoginInputSchema),
  });

  const { submitLogin, loading } = useLogin();
  const t = useTranslations("loginForm");

  useFormErrorToast(errors);
  return (
    <CardForm>
      <h1>{t("title")}</h1>
      <CardFormInner onSubmit={handleSubmit((data) => submitLogin(data))}>
        <Input
          type="text"
          label={t("email")}
          placeholder={t("email")}
          {...register("email")}
        />
        <Input
          type="password"
          label={t("password")}
          placeholder={t("password")}
          {...register("password")}
        />
        <CheckBox {...register("confirm")}>{t("remember")}</CheckBox>
        <div
          className={"mt-3"}
          style={{
            textAlign: "center",
          }}
        >
          <Button label={t("button")} isLoading={isLoading || loading} />
        </div>
      </CardFormInner>
      <CardFormBottom>
        {t("registerText")} <Link href={URL.REGISTER}>{t("registerLink")}</Link>
      </CardFormBottom>
    </CardForm>
  );
};

export default LoginForm;
